import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const prismicRepoName = 'prickle-website';

export default function useUpdatePreviewRef(
  preview: boolean,
  documentId: string
): void {
  const router = useRouter();
  useEffect(() => {
    if (router.isPreview) {
      const rawPreviewCookie = Cookies.get('io.prismic.preview');
      if (rawPreviewCookie) {
        const previewCookie = JSON.parse(rawPreviewCookie);
        const previewCookieObject =
          previewCookie[`${prismicRepoName}.prismic.io`];
        const previewCookieRef =
          previewCookieObject && previewCookieObject.preview
            ? previewCookieObject.preview
            : null;
        if (previewCookieRef && preview !== previewCookieRef) {
          return () =>
            router.push(
              `/api/preview?token=${previewCookieRef}&documentId=${documentId}`
            );
        }
      } else {
        return () => router.push('/api/exit-preview');
      }
    }
    return () => {
      return;
    };
  }, []);
}
